import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _instanceof from "@swc/helpers/src/_instanceof.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { STORYBLOK_BFF_URL } from "../../util/api";
import { getStoriesUrlParams } from "./schema";
export var getStories = function() {
    var _ref = _async_to_generator(function(params) {
        var urlParams, url, response, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    urlParams = getStoriesUrlParams.parse(params);
                    url = "".concat(STORYBLOK_BFF_URL, "/get-all-stories?").concat(urlParams.toString());
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        fetch(url)
                    ];
                case 2:
                    response = _state.sent();
                    if (response.status !== 200) {
                        throw new Error("'get-all-stories' responded with non-OK response status ".concat(response.status));
                    }
                    return [
                        2,
                        response.json()
                    ];
                case 3:
                    error = _state.sent();
                    if (_instanceof(error, Error)) {
                        // eslint-disable-next-line unicorn/prefer-type-error
                        throw new Error("'get-all-stories' endpoint threw an error: ".concat(error.message));
                    }
                    throw new Error("'get-all-stories' endpoint threw an unknown error: ".concat(error));
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getStories(params) {
        return _ref.apply(this, arguments);
    };
}();
